import { BankInfo } from '@libs/shared/types';

const _bankInfoMap = {
  aibgbbusiness: {
    id: 'aibgbbusiness',
    name: 'AIB (GB) Business',
    fullName: 'Allied Irish Bank (GB) Business',
    media: [
      { source: 'https://images.yapily.com/image/126a10ad-f6c8-4360-a29a-3ac4cd8c7308', type: 'icon' },
      { source: 'https://images.yapily.com/image/f0eb1a0c-4001-480d-9a83-74c2c187127a', type: 'logo' },
    ],
  },
  aibgb: {
    id: 'aibgb',
    name: 'AIB (GB) Personal',
    fullName: 'Allied Irish Bank (GB) Personal',
    media: [
      { source: 'https://images.yapily.com/image/0857b7d0-e38f-4c8c-9fdd-5efaac66e546', type: 'icon' },
      { source: 'https://images.yapily.com/image/c77626bd-97e2-44e4-a560-c16ee5ce0abe', type: 'logo' },
    ],
  },
  firsttrustbank: {
    id: 'firsttrustbank',
    name: 'AIB (NI)',
    fullName: 'AIB (NI)',
    media: [
      { source: 'https://images.yapily.com/image/19822174-cffa-4dcd-a31a-75278fb5a276', type: 'icon' },
      { source: 'https://images.yapily.com/image/3fe918ac-e50f-4beb-8bf8-8ed8c29d00e7', type: 'logo' },
    ],
  },
  firsttrustbankbusiness: {
    id: 'firsttrustbankbusiness',
    name: 'AIB (NI) Business',
    fullName: 'AIB (NI) Business',
    media: [
      { source: 'https://images.yapily.com/image/4932b75c-d696-4732-b8fb-36f3d7283e9f', type: 'icon' },
      { source: 'https://images.yapily.com/image/95f3e2a0-777e-418a-ac22-675ef09ffa22', type: 'logo' },
    ],
  },
  bankofirelandbusiness_uk: {
    id: 'bankofirelandbusiness_uk',
    name: 'Bank of Ireland Business UK',
    fullName: 'Bank of Ireland Business UK',
    media: [
      { source: 'https://images.yapily.com/image/4bef3f74-0b0d-4c72-ad2c-ccdb486ad07f', type: 'icon' },
      { source: 'https://images.yapily.com/image/d1ff0461-32ba-4270-88d1-1a282399f12a', type: 'logo' },
    ],
  },
  bankofireland_uk: {
    id: 'bankofireland_uk',
    name: 'Bank of Ireland UK',
    fullName: 'Bank of Ireland (UK) plc',
    media: [
      { source: 'https://images.yapily.com/image/4bef3f74-0b0d-4c72-ad2c-ccdb486ad07f', type: 'icon' },
      { source: 'https://images.yapily.com/image/f0fbffaf-7716-402a-a924-cebefe894306', type: 'logo' },
    ],
  },
  bankofscotlandbusiness: {
    id: 'bankofscotlandbusiness',
    name: 'Bank of Scotland (Business)',
    fullName: 'Bank of Scotland (Business)',
    media: [
      { source: 'https://images.yapily.com/image/dfc2ed6f-32b1-45ed-afa0-ff2791020b37', type: 'icon' },
      { source: 'https://images.yapily.com/image/b24afef8-834d-4eb4-a469-41bca60ae636', type: 'logo' },
    ],
  },
  bankofscotland: {
    id: 'bankofscotland',
    name: 'Bank of Scotland (Personal)',
    fullName: 'Bank of Scotland (Personal)',
    media: [
      { source: 'https://images.yapily.com/image/a9bcb0bb-229c-4de6-ab96-df6314fd37b9', type: 'icon' },
      { source: 'https://images.yapily.com/image/1ad73af4-b9b0-4368-a10a-fcc7806de478', type: 'logo' },
    ],
  },
  bankofscotlandcommercial_eu: {
    id: 'bankofscotlandcommercial_eu',
    name: 'Bank of Scotland EU (Commercial)',
    fullName: 'Bank of Scotland EU (Commercial)',
    media: [
      { source: 'https://images.yapily.com/image/dfc2ed6f-32b1-45ed-afa0-ff2791020b37', type: 'icon' },
      { source: 'https://images.yapily.com/image/b24afef8-834d-4eb4-a469-41bca60ae636', type: 'logo' },
    ],
  },
  bankofscotlandcommercial_uk: {
    id: 'bankofscotlandcommercial_uk',
    name: 'Bank of Scotland UK (Commercial)',
    fullName: 'Bank of Scotland UK (Commercial)',
    media: [
      { source: 'https://images.yapily.com/image/dfc2ed6f-32b1-45ed-afa0-ff2791020b37', type: 'icon' },
      { source: 'https://images.yapily.com/image/b24afef8-834d-4eb4-a469-41bca60ae636', type: 'logo' },
    ],
  },
  barclaycard: {
    id: 'barclaycard',
    name: 'Barclaycard',
    fullName: 'Barclaycard',
    media: [
      { source: 'https://images.yapily.com/image/904f3769-f459-479b-b89b-4a1ba0b86774', type: 'icon' },
      { source: 'https://images.yapily.com/image/d73333ce-e629-4684-acd8-7a4193896800', type: 'logo' },
    ],
  },
  'barclaycard-commercial-payments': {
    id: 'barclaycard-commercial-payments',
    name: 'Barclaycard Commercial Payments',
    fullName: 'Barclaycard Commercial Payments',
    media: [
      { source: 'https://images.yapily.com/image/8f988b12-0b06-4021-8bb4-30bc49341a81', type: 'icon' },
      { source: 'https://images.yapily.com/image/9bb2334b-b3ca-458b-8713-44bd843bca82', type: 'logo' },
    ],
  },
  barclays_business: {
    id: 'barclays_business',
    name: 'Barclays Business',
    fullName: 'Barclays Business',
    media: [
      { source: 'https://images.yapily.com/image/674d2584-efb9-4f66-aa7a-03aae576035c', type: 'icon' },
      { source: 'https://images.yapily.com/image/3af53a88-e06d-47d0-876f-40e360d4df74', type: 'logo' },
    ],
  },
  barclays_corporate: {
    id: 'barclays_corporate',
    name: 'Barclays Corporate',
    fullName: 'Barclays Corporate',
    media: [
      { source: 'https://images.yapily.com/image/b591ec82-9f24-4a2f-8ede-849adf11ad79', type: 'icon' },
      { source: 'https://images.yapily.com/image/c6fb60f6-07da-45c9-90cc-11ffc59c7474', type: 'logo' },
    ],
  },
  barclays: {
    id: 'barclays',
    name: 'Barclays Personal',
    fullName: 'Barclays Bank Personal',
    media: [
      { source: 'https://images.yapily.com/image/d8155160-2be4-4fb7-93cc-ba524e422cc3', type: 'icon' },
      { source: 'https://images.yapily.com/image/5b282c94-d675-4bfa-b2c4-aa622785253d', type: 'logo' },
    ],
  },
  barclays_wealth: {
    id: 'barclays_wealth',
    name: 'Barclays Wealth',
    fullName: 'Barclays Wealth',
    media: [
      { source: 'https://images.yapily.com/image/23e9bf23-37bf-4a08-ab29-cdea6c60a239', type: 'icon' },
      { source: 'https://images.yapily.com/image/eba8ee62-3256-4d9c-ab40-9b95502c1ee5', type: 'logo' },
    ],
  },
  capitalontap: {
    id: 'capitalontap',
    name: 'Capital On Tap',
    fullName: 'Capital On Tap',
    media: [
      { source: 'https://images.yapily.com/image/8076f56b-ad55-4acd-8012-77a94fb296fc', type: 'icon' },
      { source: 'https://images.yapily.com/image/77be213c-dba8-48e2-94d0-24994e540811', type: 'logo' },
    ],
  },
  capitalone_uk: {
    id: 'capitalone_uk',
    name: 'Capital One',
    fullName: 'Capital One',
    media: [
      { source: 'https://images.yapily.com/image/8342cdf5-129d-48e1-b18e-70b81f05c486', type: 'icon' },
      { source: 'https://images.yapily.com/image/976a9156-e201-4fc5-845b-f3690509ef5b', type: 'logo' },
    ],
  },
  caterallen: {
    id: 'caterallen',
    name: 'Cater Allen',
    fullName: 'Cater Allen',
    media: [
      { source: 'https://images.yapily.com/image/9daa5360-d662-418e-9edf-7771002876f3', type: 'icon' },
      { source: 'https://images.yapily.com/image/1e58b1cf-1d19-4379-a323-5962f5a2413b', type: 'logo' },
    ],
  },
  chase_uk: {
    id: 'chase_uk',
    name: 'Chase UK',
    fullName: 'Chase UK',
    media: [
      { source: 'https://images.yapily.com/image/0e349082-75cc-4a93-85cc-a2d7b7a2680a', type: 'icon' },
      { source: 'https://images.yapily.com/image/0dc70f3a-b7f9-4288-ba3a-24eeb5545c3b', type: 'logo' },
    ],
  },
  chelseabuildingsociety: {
    id: 'chelseabuildingsociety',
    name: 'Chelsea Building Society',
    fullName: 'Chelsea Building Society',
    media: [
      { source: 'https://images.yapily.com/image/73dd6a83-e203-4070-a42d-f2b9703c2260', type: 'icon' },
      { source: 'https://images.yapily.com/image/f198df67-9642-4685-b735-9f6d56d7a215', type: 'logo' },
    ],
  },
  cooperativebank: {
    id: 'cooperativebank',
    name: 'Cooperative Bank (Business)',
    fullName: 'Cooperative Bank (Business)',
    media: [
      { source: 'https://images.yapily.com/image/9d309d80-48dd-4b40-9810-945e978aa0c3', type: 'icon' },
      { source: 'https://images.yapily.com/image/d5c3e6ad-b1ec-4a98-96b2-f7653dd23254', type: 'logo' },
    ],
  },
  'cooperative-personal': {
    id: 'cooperative-personal',
    name: 'Cooperative Personal',
    fullName: 'Cooperative Personal',
    media: [
      { source: 'https://images.yapily.com/image/d4e04492-b4ee-48bb-bd33-5449df9c0789', type: 'icon' },
      { source: 'https://images.yapily.com/image/0c1f2806-208b-426e-aa1f-9f6668143e51', type: 'logo' },
    ],
  },
  'cooperative-smile': {
    id: 'cooperative-smile',
    name: 'Cooperative Smile',
    fullName: 'Cooperative Smile',
    media: [
      { source: 'https://images.yapily.com/image/2f2eb26c-ae7d-4324-b95a-e368ca243186', type: 'icon' },
      { source: 'https://images.yapily.com/image/e3895341-798d-40f2-a6ad-5271c1f28c8d', type: 'logo' },
    ],
  },
  coutts: {
    id: 'coutts',
    name: 'Coutts & Company',
    fullName: 'Coutts & Company',
    media: [
      { source: 'https://images.yapily.com/image/5f049447-3805-46fa-8e16-f3e89f6036c3', type: 'icon' },
      { source: 'https://images.yapily.com/image/be8a27ef-4508-4d7a-8e8b-f7b841a7b8e4', type: 'logo' },
    ],
  },
  cumberlandbuildingsociety: {
    id: 'cumberlandbuildingsociety',
    name: 'Cumberland Building Society',
    fullName: 'Cumberland Building Society',
    media: [
      { source: 'https://images.yapily.com/image/a9787902-659c-4447-941a-645db9d1b8c3', type: 'icon' },
      { source: 'https://images.yapily.com/image/02d90639-5fd7-4b49-b09b-58b61a442758', type: 'logo' },
    ],
  },
  danskebank_uk: {
    id: 'danskebank_uk',
    name: 'Danske Bank',
    fullName: 'Danske Bank',
    media: [
      { source: 'https://images.yapily.com/image/f387a249-720d-4bf5-95d0-5f96768dd09c', type: 'icon' },
      { source: 'https://images.yapily.com/image/9d3f51fb-86a2-42b9-8add-eb69f3fe02b2', type: 'logo' },
    ],
  },
  danskebankbusiness_uk: {
    id: 'danskebankbusiness_uk',
    name: 'Danske Bank Business UK',
    fullName: 'Danske Bank Business UK',
    media: [
      { source: 'https://images.yapily.com/image/f387a249-720d-4bf5-95d0-5f96768dd09c', type: 'icon' },
      { source: 'https://images.yapily.com/image/9d3f51fb-86a2-42b9-8add-eb69f3fe02b2', type: 'logo' },
    ],
  },
  firstdirect: {
    id: 'firstdirect',
    name: 'First Direct',
    fullName: 'First Direct',
    media: [
      { source: 'https://images.yapily.com/image/bfa8938c-75f4-4304-9056-377e8b79923d', type: 'icon' },
      { source: 'https://images.yapily.com/image/cd1901c2-ea5d-430d-8cb1-bee7bdb32090', type: 'logo' },
    ],
  },
  hsbckinetic: {
    id: 'hsbckinetic',
    name: 'HSBC Kinetic',
    fullName: 'HSBC Kinetic',
    media: [
      { source: 'https://images.yapily.com/image/fc734d3c-4480-471e-94ee-500f83ae3bae', type: 'icon' },
      { source: 'https://images.yapily.com/image/ccd56ed6-c274-4c8e-a988-6cb8dda2fb1c', type: 'logo' },
    ],
  },
  hsbccorporate: {
    id: 'hsbccorporate',
    name: 'HSBC Net',
    fullName: 'HSBC Corporate',
    media: [
      { source: 'https://images.yapily.com/image/fc734d3c-4480-471e-94ee-500f83ae3bae', type: 'icon' },
      { source: 'https://images.yapily.com/image/ccd56ed6-c274-4c8e-a988-6cb8dda2fb1c', type: 'logo' },
    ],
  },
  hsbc_uk: {
    id: 'hsbc_uk',
    name: 'HSBC Personal',
    fullName: 'HSBC Personal',
    media: [
      { source: 'https://images.yapily.com/image/fc734d3c-4480-471e-94ee-500f83ae3bae', type: 'icon' },
      { source: 'https://images.yapily.com/image/ccd56ed6-c274-4c8e-a988-6cb8dda2fb1c', type: 'logo' },
    ],
  },
  hsbcbusiness_uk: {
    id: 'hsbcbusiness_uk',
    name: 'HSBC UK Business',
    fullName: 'HSBC UK Business',
    media: [
      { source: 'https://images.yapily.com/image/da33b95f-edfd-49ae-a904-f760d85ecf40', type: 'icon' },
      { source: 'https://images.yapily.com/image/b968bc9b-f675-4bfd-b4c5-ab3aee19b167', type: 'logo' },
    ],
  },
  halifax: {
    id: 'halifax',
    name: 'Halifax Personal',
    fullName: 'Halifax Personal',
    media: [
      { source: 'https://images.yapily.com/image/9c5470ca-cb71-4dab-ba4a-c15603d3bcf7', type: 'icon' },
      { source: 'https://images.yapily.com/image/399a0b28-a171-4691-8ca7-79b3d5057e4c', type: 'logo' },
    ],
  },
  handelsbankenbusiness_uk: {
    id: 'handelsbankenbusiness_uk',
    name: 'Handelsbanken Business UK',
    fullName: 'Handelsbanken Business UK',
    media: [
      { source: 'https://images.yapily.com/image/a722b3b6-7cb9-42b6-810a-5a33d0184ede', type: 'icon' },
      { source: 'https://images.yapily.com/image/0a1a3f47-3fb3-4eac-bc27-fb2ae0bbede6', type: 'logo' },
    ],
  },
  handelsbanken_uk: {
    id: 'handelsbanken_uk',
    name: 'Handelsbanken UK',
    fullName: 'Handelsbanken UK',
    media: [
      { source: 'https://images.yapily.com/image/dd5d8c50-73b9-4bdf-88a1-f59c53d9a82b', type: 'icon' },
      { source: 'https://images.yapily.com/image/af80d692-854c-45b1-8d67-1286d2819663', type: 'logo' },
    ],
  },
  hoaresbank: {
    id: 'hoaresbank',
    name: 'Hoares Bank',
    fullName: 'C. Hoare & Co.',
    media: [
      { source: 'https://images.yapily.com/image/9917712f-f3b4-44fc-92b0-2d7fe71b9b1e', type: 'icon' },
      { source: 'https://images.yapily.com/image/f63ff139-dd8b-48d4-99fc-577a906e3e75', type: 'logo' },
    ],
  },
  ing: {
    id: 'ing',
    name: 'ING',
    fullName: 'ING',
    media: [
      { source: 'https://images.yapily.com/image/115742bf-0e4e-49d9-ad86-df5afc385c00', type: 'icon' },
      { source: 'https://images.yapily.com/image/90e14554-7ea1-440a-82ec-c0adcca5b497', type: 'logo' },
    ],
  },
  lloydsbusiness: {
    id: 'lloydsbusiness',
    name: 'Lloyds (Business)',
    fullName: 'Lloyds (Business)',
    media: [
      { source: 'https://images.yapily.com/image/687ddef5-dd48-476a-b9a7-38e294431201', type: 'icon' },
      { source: 'https://images.yapily.com/image/0248cab7-c834-41c7-b837-20a32fe7ff38', type: 'logo' },
    ],
  },
  lloyds: {
    id: 'lloyds',
    name: 'Lloyds (Personal)',
    fullName: 'Lloyds (Personal)',
    media: [
      { source: 'https://images.yapily.com/image/0b0567cd-1fe6-4ff2-a82e-da53361b6fef', type: 'icon' },
      { source: 'https://images.yapily.com/image/da8f3859-978a-4027-863f-5d01d794d4c4', type: 'logo' },
    ],
  },
  lloydscommercial_eu: {
    id: 'lloydscommercial_eu',
    name: 'Lloyds EU (Commercial)',
    fullName: 'Lloyds EU (Commercial)',
    media: [
      { source: 'https://images.yapily.com/image/687ddef5-dd48-476a-b9a7-38e294431201', type: 'icon' },
      { source: 'https://images.yapily.com/image/0248cab7-c834-41c7-b837-20a32fe7ff38', type: 'logo' },
    ],
  },
  lloydscommercial_uk: {
    id: 'lloydscommercial_uk',
    name: 'Lloyds UK (Commercial)',
    fullName: 'Lloyds UK (Commercial)',
    media: [
      { source: 'https://images.yapily.com/image/687ddef5-dd48-476a-b9a7-38e294431201', type: 'icon' },
      { source: 'https://images.yapily.com/image/0248cab7-c834-41c7-b837-20a32fe7ff38', type: 'logo' },
    ],
  },
  msbank: {
    id: 'msbank',
    name: 'M&S Bank',
    fullName: 'M&S Bank',
    media: [
      { source: 'https://images.yapily.com/image/9932ddb9-0457-4c86-8f87-ccf1a1420ff1', type: 'icon' },
      { source: 'https://images.yapily.com/image/9b006d04-b799-44d5-82de-fe3ce49118e6', type: 'logo' },
    ],
  },
  mbna: {
    id: 'mbna',
    name: 'MBNA Personal',
    fullName: 'MBNA Personal',
    media: [
      { source: 'https://images.yapily.com/image/ec7cea33-700a-45fe-a819-558cb7908426', type: 'icon' },
      { source: 'https://images.yapily.com/image/beefedca-31a5-412a-9087-15a074fc2a8b', type: 'logo' },
    ],
  },
  metro: {
    id: 'metro',
    name: 'Metro Bank',
    fullName: 'Metro Bank PLC',
    media: [
      { source: 'https://images.yapily.com/image/9c06321d-c54a-457f-9222-6f39e32feed8', type: 'icon' },
      { source: 'https://images.yapily.com/image/ca4c48a6-79d7-44d1-a14f-c21247a3e688', type: 'logo' },
    ],
  },
  mettle: {
    id: 'mettle',
    name: 'Mettle',
    fullName: 'Mettle',
    media: [
      { source: 'https://images.yapily.com/image/f3fa5555-d9b6-40cb-be4a-470b15e014c2', type: 'icon' },
      { source: 'https://images.yapily.com/image/037f604f-eb33-4c66-b865-e1277ff926ce', type: 'logo' },
    ],
  },
  monzo_ob: {
    id: 'monzo_ob',
    name: 'Monzo',
    fullName: 'Monzo',
    media: [
      { source: 'https://images.yapily.com/image/f70dc041-c7a5-47d3-9c6b-846778eac01a', type: 'icon' },
      { source: 'https://images.yapily.com/image/332bb781-3cc2-4f3e-ae79-1aba09fac991', type: 'logo' },
    ],
  },
  'natwest-clearspend': {
    id: 'natwest-clearspend',
    name: 'NatWest ClearSpend',
    fullName: 'NatWest ClearSpend',
    media: [
      { source: 'https://images.yapily.com/image/6c52c612-cc74-4a12-98fa-e9da464f59c6', type: 'icon' },
      { source: 'https://images.yapily.com/image/0f2c716c-f9f4-4954-9d82-1d36150b3006', type: 'logo' },
    ],
  },
  nationwide: {
    id: 'nationwide',
    name: 'Nationwide',
    fullName: 'Nationwide Building Society',
    media: [
      { source: 'https://images.yapily.com/image/5759e5a2-f537-49e7-b8a6-9eaa293fbad8', type: 'icon' },
      { source: 'https://images.yapily.com/image/52d4151c-cedb-45e0-932b-0778c557e3e8', type: 'logo' },
    ],
  },
  natwest: {
    id: 'natwest',
    name: 'Natwest',
    fullName: 'National Westminster Bank',
    media: [
      { source: 'https://images.yapily.com/image/06a3822f-2890-4055-b1a1-d352532b6340', type: 'icon' },
      { source: 'https://images.yapily.com/image/0f2c716c-f9f4-4954-9d82-1d36150b3006', type: 'logo' },
    ],
  },
  natwestbusiness: {
    id: 'natwestbusiness',
    name: 'Natwest Bankline',
    fullName: 'Natwest Bankline',
    media: [
      { source: 'https://images.yapily.com/image/26d650e9-591e-41f8-ad97-d1c49566e634', type: 'icon' },
      { source: 'https://images.yapily.com/image/75c17eeb-79cb-429b-b8bc-17c4ceedff18', type: 'logo' },
    ],
  },
  'natwest-sandbox': {
    id: 'natwest-sandbox',
    name: 'Natwest Sandbox',
    fullName: 'Natwest Sandbox',
    media: [
      { source: 'https://images.yapily.com/image/06a3822f-2890-4055-b1a1-d352532b6340', type: 'icon' },
      { source: 'https://images.yapily.com/image/0f2c716c-f9f4-4954-9d82-1d36150b3006', type: 'logo' },
    ],
  },
  paypal: {
    id: 'paypal',
    name: 'PayPal',
    fullName: 'PayPal',
    media: [
      { source: 'https://images.yapily.com/image/d4909b7f-8dd4-4a9d-b2b4-e4ab19a48d82', type: 'icon' },
      { source: 'https://images.yapily.com/image/7db13e53-b516-4f83-a032-eccf4d03b5ba', type: 'logo' },
    ],
  },
  payoneer_uk: {
    id: 'payoneer_uk',
    name: 'Payoneer - UK',
    fullName: 'Payoneer - UK',
    media: [
      { source: 'https://images.yapily.com/image/c8378ed7-7a7e-4272-a108-7328ea08d8fd', type: 'icon' },
      { source: 'https://images.yapily.com/image/5209b587-56f9-40cf-bdbd-89f46ad5f0f5', type: 'logo' },
    ],
  },
  'rbsinternational-clearspend': {
    id: 'rbsinternational-clearspend',
    name: 'RBS International ClearSpend',
    fullName: 'RBS International ClearSpend',
    media: [
      { source: 'https://images.yapily.com/image/661c8501-d393-41e6-865f-bec845e43e9e', type: 'icon' },
      { source: 'https://images.yapily.com/image/7a689514-dda3-4550-917b-c0243a9eabd3', type: 'logo' },
    ],
  },
  revolut: {
    id: 'revolut',
    name: 'Revolut',
    fullName: 'Revolut',
    media: [
      { source: 'https://images.yapily.com/image/fdd1045e-daa8-485c-9315-87fcc2e06e6c', type: 'icon' },
      { source: 'https://images.yapily.com/image/e6abe21c-5823-471a-a62d-97959c0c8417', type: 'logo' },
    ],
  },
  rbs: {
    id: 'rbs',
    name: 'Royal Bank of Scotland',
    fullName: 'Royal Bank of Scotland',
    media: [
      { source: 'https://images.yapily.com/image/694b1b08-bb78-40d8-bf58-aae12a40de99', type: 'icon' },
      { source: 'https://images.yapily.com/image/7a689514-dda3-4550-917b-c0243a9eabd3', type: 'logo' },
    ],
  },
  rbsbusiness: {
    id: 'rbsbusiness',
    name: 'Royal Bank of Scotland Bankline',
    fullName: 'Royal Bank of Scotland Bankline',
    media: [
      { source: 'https://images.yapily.com/image/23735cc4-18f6-4dbc-b67a-001ca9040c8c', type: 'icon' },
      { source: 'https://images.yapily.com/image/0aaec899-70ac-47e9-ab53-f53587c88c3c', type: 'logo' },
    ],
  },
  'rbs-clearspend': {
    id: 'rbs-clearspend',
    name: 'Royal Bank of Scotland ClearSpend',
    fullName: 'Royal Bank of Scotland ClearSpend',
    media: [
      { source: 'https://images.yapily.com/image/661c8501-d393-41e6-865f-bec845e43e9e', type: 'icon' },
      { source: 'https://images.yapily.com/image/7a689514-dda3-4550-917b-c0243a9eabd3', type: 'logo' },
    ],
  },
  smbc_uk: {
    id: 'smbc_uk',
    name: 'SMBC - UK',
    fullName: 'Sumitomo Mitsui Banking Corporation',
    media: [
      { source: 'https://images.yapily.com/image/ccddb088-c0d3-40f1-88bc-e789ac79ebb7', type: 'icon' },
      { source: 'https://images.yapily.com/image/d9b0e420-3fc0-46dc-8965-89cfb021ea43', type: 'logo' },
    ],
  },
  sainsburysbank: {
    id: 'sainsburysbank',
    name: "Sainsbury's Bank",
    fullName: "Sainsbury's Bank PLC",
    media: [
      { source: 'https://images.yapily.com/image/794c0539-cce3-4997-8e3e-8bd2c29f1b7a', type: 'icon' },
      { source: 'https://images.yapily.com/image/cdf0b98f-7d10-4765-8357-cb127d22b160', type: 'logo' },
    ],
  },
  santander_uk: {
    id: 'santander_uk',
    name: 'Santander',
    fullName: 'Santander UK Plc',
    media: [
      { source: 'https://images.yapily.com/image/a32a626b-92e4-449f-843a-007ca9bb0240', type: 'icon' },
      { source: 'https://images.yapily.com/image/2caaa7bc-400b-4d63-9732-805e94739555', type: 'logo' },
    ],
  },
  'soldo-token': {
    id: 'soldo-token',
    name: 'Soldo UK',
    fullName: 'Soldo UK',
    media: [
      { source: 'https://images.yapily.com/image/fc6c714c-837f-4ba4-a4b8-c7b95884c8b6', type: 'icon' },
      { source: 'https://images.yapily.com/image/17a070d2-d945-403a-b9d7-d7b89b74344c', type: 'logo' },
    ],
  },
  starling_ob: {
    id: 'starling_ob',
    name: 'Starling',
    fullName: 'Starling',
    media: [
      { source: 'https://images.yapily.com/image/33318c83-aecd-45e7-aa33-882e5de1b092', type: 'icon' },
      { source: 'https://images.yapily.com/image/a4abe81a-a705-45d0-9aaa-2ed7f70d352a', type: 'logo' },
    ],
  },
  tsb: {
    id: 'tsb',
    name: 'TSB Bank',
    fullName: 'TSB Bank plc',
    media: [
      { source: 'https://images.yapily.com/image/626cd8d9-5b54-4b0b-b3d1-a621890e7446', type: 'icon' },
      { source: 'https://images.yapily.com/image/5fd1c193-2a15-43eb-b8fd-7dc4b6f046df', type: 'logo' },
    ],
  },
  tescobank: {
    id: 'tescobank',
    name: 'Tesco Bank',
    fullName: 'Tesco Bank',
    media: [
      { source: 'https://images.yapily.com/image/b0152001-2af2-4f31-a713-0bda70339bfb', type: 'icon' },
      { source: 'https://images.yapily.com/image/eef94f98-a4fa-441f-ba6c-fa5f996f41ee', type: 'logo' },
    ],
  },
  tide: {
    id: 'tide',
    name: 'Tide',
    fullName: 'Tide',
    media: [
      { source: 'https://images.yapily.com/image/c8d4547b-5c35-43c2-ae21-e902268c5886', type: 'icon' },
      { source: 'https://images.yapily.com/image/8d770e46-34e8-4075-9496-a994bbaf1544', type: 'logo' },
    ],
  },
  ulsterbank_uk: {
    id: 'ulsterbank_uk',
    name: 'Ulster Bank (UK)',
    fullName: 'Ulster Bank (UK)',
    media: [
      { source: 'https://images.yapily.com/image/6772712b-149c-48ba-b0ce-905887fda292', type: 'icon' },
      { source: 'https://images.yapily.com/image/99031987-443f-4e95-a087-b28c91ff0258', type: 'logo' },
    ],
  },
  ulsterbankbusiness_uk: {
    id: 'ulsterbankbusiness_uk',
    name: 'Ulster Bank Bankline (NI)',
    fullName: 'Ulster Bank Bankline (NI)',
    media: [
      { source: 'https://images.yapily.com/image/6772712b-149c-48ba-b0ce-905887fda292', type: 'icon' },
      { source: 'https://images.yapily.com/image/99031987-443f-4e95-a087-b28c91ff0258', type: 'logo' },
    ],
  },
  'ulsterbank-clearspend_uk': {
    id: 'ulsterbank-clearspend_uk',
    name: 'Ulster Bank NI ClearSpend',
    fullName: 'Ulster Bank NI ClearSpend',
    media: [
      { source: 'https://images.yapily.com/image/8eaf3207-946a-4da9-9034-047e709f3fb6', type: 'icon' },
      { source: 'https://images.yapily.com/image/3929f7a2-870f-4cd0-9ec1-445a78273c15', type: 'logo' },
    ],
  },
  unitytrust: {
    id: 'unitytrust',
    name: 'Unity Trust',
    fullName: 'Unity Trust Bank',
    media: [
      { source: 'https://images.yapily.com/image/b3be6cc5-576f-4328-ba46-e7d6da930f08', type: 'icon' },
      { source: 'https://images.yapily.com/image/829b0a68-4cd5-4abf-b301-67d05bd6df36', type: 'logo' },
    ],
  },
  'vanquis-bank': {
    id: 'vanquis-bank',
    name: 'Vanquis Bank',
    fullName: 'Vanquis Bank',
    media: [
      { source: 'https://images.yapily.com/image/eeb4929a-5c4d-4671-b884-1c6d78594ac9', type: 'icon' },
      { source: 'https://images.yapily.com/image/1013ec08-84d2-4c0c-b4ef-f1101167c59e', type: 'logo' },
    ],
  },
  virginmoney: {
    id: 'virginmoney',
    name: 'Virgin Money',
    fullName: 'Virgin Money',
    media: [
      { source: 'https://images.yapily.com/image/fcac9f73-b37c-44a7-a46c-6047c5966c5b', type: 'icon' },
      { source: 'https://images.yapily.com/image/0294758d-ae35-4023-826d-9dc59fc15db8', type: 'logo' },
    ],
  },
  virginmoney_essential: {
    id: 'virginmoney_essential',
    name: 'Virgin Money (Essential)',
    fullName: 'Virgin Money (Essential)',
    media: [
      { source: 'https://images.yapily.com/image/2bc464ec-2ef8-4ddb-bb21-7246c8ae988a', type: 'icon' },
      { source: 'https://images.yapily.com/image/666ef505-a643-4bb0-a17d-654a44e5ea60', type: 'logo' },
    ],
  },
  'wise-live': {
    id: 'wise-live',
    name: 'Wise',
    fullName: 'Wise',
    media: [
      { source: 'https://images.yapily.com/image/78e570a4-3fcc-458d-b449-af9d1b09d462', type: 'icon' },
      { source: 'https://images.yapily.com/image/fa681bd5-512d-4f5c-a53b-086595b226bb', type: 'logo' },
    ],
  },
  yorkshirebuildingsociety: {
    id: 'yorkshirebuildingsociety',
    name: 'Yorkshire Building Society',
    fullName: 'Yorkshire Building Society',
    media: [
      { source: 'https://images.yapily.com/image/eeb082df-042f-4ec8-bbc4-7e6cd9f9d124', type: 'icon' },
      { source: 'https://images.yapily.com/image/6d393f2f-996c-459f-b4b8-c681716877e8', type: 'logo' },
    ],
  },
  cashplus: {
    id: 'cashplus',
    name: 'Zempler Bank (Formerly Cashplus)',
    fullName: 'Zempler Bank (Formerly Cashplus)',
    media: [
      { source: 'https://images.yapily.com/image/883cc7a4-f08b-4d94-aafc-73990d28896f', type: 'icon' },
      { source: 'https://images.yapily.com/image/59345398-99d7-40ac-b7d4-ebeb7a7f9147', type: 'logo' },
    ],
  },
  thinkmoney: {
    id: 'thinkmoney',
    name: 'thinkmoney',
    fullName: 'thinkmoney',
    media: [
      { source: 'https://images.yapily.com/image/0d41e6b6-c0cc-49e0-98a3-5ea10acddf42', type: 'icon' },
      { source: 'https://images.yapily.com/image/4c261929-64bf-4d21-852d-000166fea12b', type: 'logo' },
    ],
  },
};
type BankId = keyof typeof _bankInfoMap;
const bankInfoMap: Record<BankId, BankInfo> = _bankInfoMap;
export { bankInfoMap, BankId };
